module.exports = __webpack_public_path__ + "static/media/error_face.37999464.svg";